<template>
  <div>
    <b-container class="container--max-750 text-center mt-6">
      <h1 class="h3 mb-4">{{ $t("lang.label_certificate_step2") }}</h1>
    </b-container>
    <b-container class="mt-6">
      <b-row class="row-cols-2 row-cols-md-3 mx-n2 mx-sm-n3 mt-n3 mt-sm-n5 justify-content-center">
        <b-col class="px-2 px-sm-3 mt-3 mt-sm-5" v-b-tooltip.noninteractive.left.hover="$t('lang.tooltip_certificate_create_fromExisting')">
          <router-link class="c-card" v-bind:class="{ 'is-selected': isFromExistingSelected }" to="pqc/from-existing">
            <wizard-button-from-existing></wizard-button-from-existing>
          </router-link>
        </b-col>
        <b-col class="px-2 px-sm-3 mt-3 mt-sm-5" v-b-tooltip.noninteractive.right.hover="$t('lang.tooltip_certificate_create_fromKeyPair')">
          <router-link class="c-card" v-bind:class="{ 'is-selected': isFromNewKeypairSelected }" to="pqc/from-new-keypair">
            <wizard-button-from-new-keypair></wizard-button-from-new-keypair>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import WizardButtonFromExisting from "../../components/wizard/WizardButtonFromExisting";
import WizardButtonFromNewKeypair from "../../components/wizard/WizardButtonFromNewKeypair";
import CertificateSource from "../../enums/CertificateSource";

export default {
  name: "CreateCertificateWizardStep2Pqc",
  props: {
    certificateType: String,
    certificateSource: String
  },
  computed: {
    isFromExistingSelected() {
      return this.certificateSource === CertificateSource.FROM_EXISTING;
    },
    isFromNewKeypairSelected() {
      return this.certificateSource === CertificateSource.FROM_NEW_KEYPAIR;
    }
  },
  components: {
    WizardButtonFromExisting,
    WizardButtonFromNewKeypair
  }
};
</script>
